import { emitGame, GameEvents } from '../events';
import { clearInventoryFilter, setInventoryFilter, type EquipFilter } from '../equipment';
import { playerState } from '../player-state';
import { returnIngredientsToInventory } from './forge';

let forgeModal: { open: () => void; close: () => void } | null = null;
let inventoryModal: { open: (opts?: { craftingLayout?: boolean }) => void; close: () => void } | null = null;
let forgeOpen = false;

export function registerCraftingModals(
  forge: { open: () => void; close: () => void },
  inventory: { open: (opts?: { craftingLayout?: boolean }) => void; close: () => void },
) {
  forgeModal = forge;
  inventoryModal = inventory;
}

export function isForgeOpen() {
  return forgeOpen;
}

export function enterCraftingMode() {
  if (!forgeModal || !inventoryModal) return;
  clearInventoryFilter();
  playerState.craftingIngredients ??= { 1: null, 2: null };
  forgeOpen = true;
  forgeModal.open();
  inventoryModal.open({ craftingLayout: true });
  emitGame(GameEvents.FORGE_OPEN);
}

export function exitCraftingMode() {
  if (!forgeModal || !inventoryModal) return;
  returnIngredientsToInventory();
  forgeOpen = false;
  clearInventoryFilter();
  forgeModal.close();
  inventoryModal.close();
}

export function openInventory(filter: EquipFilter | null = null) {
  setInventoryFilter(filter);
  inventoryModal?.open({ craftingLayout: false });
  emitGame(GameEvents.INVENTORY_OPEN, { filter });
  emitGame(GameEvents.HUD_REFRESH);
}
